import React from 'react';
import styled from 'styled-components';
import {NavLink} from 'react-router-dom';

// Components
import StyledPageContent from '../components/StyledPage';
import Button from '../components/Button';

// Assets
import logo from '../assets/images/logo.svg';

const StyledPage = styled(StyledPageContent)`
  .title-wrapper {
    text-align: center;
    margin-bottom: 2rem;
  }
  .event-title {
    margin: .5rem 0;
    font-size: 1.5rem;
  }
  label {
    padding: 1rem;
  }
  input {
    margin: 4px;
    margin-right: 8px;
  }
  .confirmation-wrapper {
    display: flex;
    flex-direction: column;
    text-align: center;
  }
`

export default  () => {
    return (
        <StyledPage>
            <div className="title-wrapper">
                <h1>Confirma tu solicitúd</h1>
                <div className="event-title">Partido Chivas vs América torneo Lorem Ipsum</div>
            </div>
            <div className="base-content">
                <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Eaque error illo eos, quaerat, numquam assumenda voluptatem odio est minima, nobis impedit aliquid qui vitae ducimus ullam maiores! Modi, molestiae quis!</p>
            </div>
            <div className="confirmation-wrapper">
                <label htmlFor="confirm-checkbox">
                    <input id="confirm-checkbox" type="checkbox"/>
                    <span>He leído y acepto los <a href="#">términos y condiciones de servicio</a></span>
                </label>
                <div>
                    <Button>Aceptar</Button>
                </div>
            </div>
        </StyledPage>
    )
}

